import React, { useState, useEffect, useCallback, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Preloader from "../../components/Preloader";
import Input from "../../components/Input";
import Select from "../../components/Select";
import { SaleService } from "../../services/SaleService";
import { TypesService } from "../../services/TypesService";
import { toast } from "react-toastify";
import { ReciboService } from "../../services/ReciboService";
import { DollarSignIcon } from "lucide-react";
import { AuthContext } from "../../context/AuthContext";

const RegistrarReceipts = () => {
    const { token } = useContext(AuthContext);
    const navigate = useNavigate();
    const { id, j } = useParams();
    const [error, setError] = useState("");
    const [success] = useState("");
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({
        reciboId: "",
        importe: "",
        contactabilidadValidaciones: "",
        tematicoValidaciones: "",
        numeroContactado: "",
        observacionBack: "",
    });
    const [errors, setErrors] = useState({});

    const [tematicList, setTematicList] = useState([]);
    const [contactabilidadList, setContactabilidadList] = useState([]);
    const [data, setData] = useState({});
    const [reportadas, setReportadas] = useState([]);
    const [recibos, setRecibos] = useState([]);
    const onlyRead = j === "only";

    const handleBackToList = () => {
        navigate("/admin/recibos");
    };

    const handleChange = (field, value) => {
        setForm(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const validateForm = () => {
        let newErrors = {};

        if (!form.reciboId) {
            newErrors.importe = "Debe seleccionar un recibo";
        }

        if (!form.contactabilidadValidaciones.trim()) {
            newErrors.contactabilidadValidaciones = "Debe seleccionar la contactabilidad";
        }
        if (!form.tematicoValidaciones.trim()) {
            newErrors.tematicoValidaciones = "Debe seleccionar un temático";
        }
        if (!form.numeroContactado.trim()) {
            newErrors.numeroContactado = "Debe ingresar el número contactado";
        } else if (form.numeroContactado.length > 11) { newErrors.numeroContactado = "No puede tener más de 11 caracteres"; }
        if (!form.observacionBack.trim()) {
            newErrors.observacionBack = "La observación es obligatoria";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const fetchSeguimientoInstalado = useCallback(async () => {
        setLoading(true);
        try {
            const responseTematic = await TypesService.get({
                token: token,
                table: 'tematico_cobranza'
            });
            const responseStatus = await TypesService.get({
                token: token,
                table: 'contactabilidad_cobranzas'
            });

            setContactabilidadList(responseStatus);
            setTematicList(responseTematic);

            const responseReportadas = await ReciboService.getSeguimientoPagos({
                token: token,
                vid: id
            });
            setReportadas(responseReportadas);

            const responseRecibos = await ReciboService.getRecibos({
                token: token,
                vid: id
            });
            setRecibos(responseRecibos);

            const responseAvance = await SaleService.fetchVentaPorId(token, id);
            setData(responseAvance.data);

            if (responseAvance && responseAvance.data.venta.id_estado_cliente !== 2) {
                navigate("/admin/recibos");
                return;
            }
        } catch (error) {
            console.error("Error al obtener la venta:", error);
        } finally {
            setLoading(false);
        }
    }, [id, token, navigate]);

    useEffect(() => {
        if (id) {
            fetchSeguimientoInstalado();
        }
    }, [id, fetchSeguimientoInstalado]);

    const handleSelectRecibo = (recibo) => {
        handleChange("importe", recibo.importe || 0);
        handleChange("reciboId", recibo.id);
    };

    const handleConsultarEstadoPago = async () => {

        if (!data.venta.codigo_venta_cliente) {
            toast.error("Por favor ingrese el código de venta cliente.");
            return;
        }
        setLoading(true);
        try {
            const response = await ReciboService.getEstadoPago({
                codigo_cliente: data.venta.codigo_venta_cliente,
                token
            });

            if (response.success) {
                fetchSeguimientoInstalado();
                toast.success("Pagos Actualizado exitosamente")
            }

        } catch (error) {
            console.error("Error al consultar:", error);
            toast.error("No se pudo obtener el estado de pago.");
        } finally {
            setLoading(false);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const isValid = validateForm(); if (!isValid) { setLoading(false); return; }
        try {
            const response = await ReciboService.createSeguimientoPago({
                token: token,
                formData: {
                    id_venta: id,
                    reciboId: form.reciboId,
                    importe: form.importe,
                    contactabilidadValidaciones: form.contactabilidadValidaciones,
                    tematicoValidaciones: form.tematicoValidaciones,
                    numeroContactado: form.numeroContactado,
                    observacionBack: form.observacionBack,
                    origen: 'web'
                }
            });
            if (response.success) {
                toast.success(response.message);
                setLoading(false);
                setForm({
                    reciboId: "",
                    importe: "",
                    contactabilidadValidaciones: "",
                    tematicoValidaciones: "",
                    numeroContactado: "",
                    observacionBack: "",
                });
                fetchSeguimientoInstalado();
            } else {
                setError(response.message);
            }
        } catch (err) {
            console.error("Detalle del error al registrar seguimiento:", err);
            setError("Error al registrar el seguimiento.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="ventas-admin-content">
            {loading && <Preloader />}
            <div className="breadcrumb-container">
                <button type="button" className="breadcrumb-link" onClick={handleBackToList}>
                    ← Listado de instaladas
                </button>
                <span className="breadcrumb-current"> / Cobranzas</span>
            </div>
            <div className=" nuevo-producto-card">
                <div className="flex justify-between gap-20">
                    <div className="w-70 ">
                        <div className="flex justify-between gap-20">
                            <div className="w-40 ">
                                <div className="ventas-table-wrapper pt-40">
                                    <table className="ventas-table">
                                        <thead>
                                            <tr>
                                                <th># Recibo</th>
                                                <th>F. Vence</th>
                                                <th className="ventas-acciones">Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {recibos.map((r, k) => {
                                                const isPagado = r.estado === 3;

                                                return (
                                                    <tr
                                                        key={r.id}
                                                        style={{
                                                            cursor: isPagado ? 'not-allowed' : 'pointer',
                                                            opacity: isPagado ? 0.6 : 1
                                                        }}
                                                        className={`
          ${form.reciboId === r.id ? 'selected-row' : ''} 
          ${isPagado ? 'row-disabled' : ''}
        `}
                                                    >
                                                        <td>
                                                            <button
                                                                type="button"
                                                                onClick={() => !isPagado && handleSelectRecibo(r)}
                                                                style={{ background: "none", border: "none", padding: 0, cursor: "inherit", color: "inherit", font: "inherit", width: "100%", textAlign: "left", display: "block" }}
                                                            >
                                                                {r.numero}
                                                            </button>
                                                        </td>
                                                        <td>{new Date(r.fecha_vencimiento).toLocaleDateString()}</td>
                                                        <td className="ventas-acciones">
                                                            {isPagado ? (
                                                                <span className="badge-pagado">PAGADO</span>
                                                            ) : (
                                                                r.estado_recibo
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="w-60 ">
                                <span className="nueva-venta-instalada-title"> Seguimiento de Pagos</span>
                                <div className="dashboard-card nueva-venta-responsive">
                                    <form
                                        className="nueva-venta-form"
                                        onSubmit={handleSubmit}
                                        autoComplete="off"
                                    >
                                        {error && <div className="error-message">{error}</div>}
                                        {success && <div className="success-message">{success}</div>}

                                        <div className="form-grid-columns">
                                            <div className="input-group-flex">
                                                <div className="input-wrapper">
                                                    <Input title="Importe Pagar" value={form.importe} setValue={(val) => handleChange("importe", val)} placeholder="" disable={true} required={true} />
                                                </div>
                                                {errors.importe && <span className="error">{errors.importe}</span>}
                                                <button type="button" className="info-icon-wrapper" onClick={() => handleConsultarEstadoPago()}>
                                                    <DollarSignIcon size={28} />
                                                </button>
                                            </div>
                                            <div className="">
                                                <Select
                                                    title="Contactabilidad"
                                                    value={form.contactabilidadValidaciones}
                                                    setValue={(val) => handleChange("contactabilidadValidaciones", val)}
                                                    options={[
                                                        { id: 0, nombre: 'Seleccione' },
                                                        ...contactabilidadList
                                                    ]}
                                                    disable={onlyRead}
                                                    required={true}
                                                />
                                                {errors.contactabilidadValidaciones && <span className="error">{errors.contactabilidadValidaciones}</span>}
                                            </div>
                                        </div>

                                        <div className="form-grid-columns">
                                            <div className="">
                                                <Input title="Num. contactado" value={form.numeroContactado} setValue={(val) => handleChange("numeroContactado", val)} placeholder="Ingrese" disable={onlyRead} required={true} />
                                                {errors.numeroContactado && <span className="error">{errors.numeroContactado}</span>}
                                            </div>
                                            <div className="">
                                                <Select title="Temático Validaciones" value={form.tematicoValidaciones} setValue={(val) => handleChange("tematicoValidaciones", val)} options={[
                                                    {
                                                        id: 0,
                                                        nombre: 'Seleccione'
                                                    },
                                                    ...tematicList
                                                ]} disable={onlyRead} required={true} />
                                                {errors.tematicoValidaciones && <span className="error">{errors.tematicoValidaciones}</span>}
                                            </div>
                                        </div>

                                        <div className="form-grid-2">
                                            <div className="">
                                                <Input title="Observación" value={form.observacionBack} setValue={(val) => handleChange("observacionBack", val)} placeholder="" type="textarea" disable={onlyRead} rows={6} required={true} />
                                                {errors.observacionBack && <span className="error">{errors.observacionBack}</span>}
                                            </div>
                                            <div className="">
                                                <button
                                                    className="btn btn-primary w-full "
                                                    type="submit"
                                                    disabled={loading || onlyRead}
                                                >
                                                    {loading
                                                        ? "Procesando..."
                                                        : "Registrar"
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="ventas-table-wrapper pt-40">
                            <table className="ventas-table">
                                <thead>
                                    <tr>
                                        <th>F. Gestión</th>
                                        <th>Back</th>
                                        <th>Contactabilidad</th>
                                        <th>Temático</th>
                                        <th>Nro. Contactado</th>
                                        <th>Observación</th>
                                        <th className="ventas-acciones"># Contac</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        reportadas.map((r, k) => (
                                            <tr key={r.id}>
                                                <td>{new Date(r.fechaHoraSeguimiento).toLocaleDateString()}</td>
                                                <td>{r.usuario_nombre} {r.usuario_apellido_paterno} {r.usuario_apellido_materno}</td>
                                                <td>{r.contactabilidad}</td>
                                                <td>{r.tematico}</td>
                                                <td>{r.numeroContactado}</td>
                                                <td>{r.ObservacionBack}</td>
                                                <td >{r.item_correlativo}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="w-30 bl-1">
                        {data ? (
                            <div className="container-gray">
                                <p>Asesor - {`${data?.venta?.nombre_vendedor || ''} ${data?.venta?.apellido_vendedor || ''}`}</p>
                                <p>SUPERVISOR - {data?.venta?.supervisor}</p>
                                <p>CÓDIGO CLIENTE - {data?.venta?.codigo_venta_cliente}</p>
                                <p>ESTADO - {data?.venta?.estado_cliente}</p>
                                <p>TIPO DOCUMENTO - {data?.cliente?.tipo_documento}</p>
                                <p>NÚMERO DOCUMENTO - {data?.cliente?.numero_documento}</p>
                                <p>NOMBRES COMPLETOS / RAZÓN SOCIAL</p>
                                <p>{`${data?.cliente?.cliente_razon_social} `}</p>
                                <p>TELÉFONO: {data?.cliente?.telefono_1}</p>
                                <p>TELÉFONO: {data?.cliente?.telefono_2}</p>
                                <p>TELÉFONO: {data?.cliente?.telefono_3}</p>
                            </div>
                        ) : (
                            <div className="container-gray">
                                <p>Cargando datos...</p>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default RegistrarReceipts;
